import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = {
  role: "group",
  class: "form-group"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("label", {
  class: "col-form-label col-sm-3",
  style: {"padding-left":"0px"}
}, " 카테고리 ", -1)
const _hoisted_6 = {
  class: "col-sm-12",
  style: {"padding-left":"0px"}
}
const _hoisted_7 = /*#__PURE__*/_createVNode("option", {
  value: "",
  selected: "",
  disabled: ""
}, "선택...", -1)
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", null, "제목", -1)
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", null, "미리보기 URL", -1)
const _hoisted_12 = { class: "form-group grid" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", null, "내용", -1)
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", null, "노출 순서", -1)
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "col-sm-9" }
const _hoisted_19 = /*#__PURE__*/_createVNode("label", null, "조회수 표시", -1)
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "col-sm-9" }
const _hoisted_25 = /*#__PURE__*/_createVNode("label", null, "포스트 표시", -1)
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = { class: "col-sm-9" }
const _hoisted_31 = /*#__PURE__*/_createVNode("label", null, "포스트 목록에서 맨 위 고정", -1)
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_34 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_35 = { class: "form-group row ml-0" }
const _hoisted_36 = { class: "col-md-2" }
const _hoisted_37 = /*#__PURE__*/_createVNode("label", null, "앱 홈 화면에 표시", -1)
const _hoisted_38 = { class: "form-group" }
const _hoisted_39 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_40 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_41 = { class: "col-md-10" }
const _hoisted_42 = /*#__PURE__*/_createVNode("label", null, "앱 홈 화면 표시 순서", -1)
const _hoisted_43 = { class: "form-group" }
const _hoisted_44 = { class: "col-sm-9" }
const _hoisted_45 = /*#__PURE__*/_createVNode("label", null, "화면 좌우 여백 없애기", -1)
const _hoisted_46 = { class: "form-group" }
const _hoisted_47 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_48 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_49 = { class: "form-group" }
const _hoisted_50 = { class: "col-sm-9" }
const _hoisted_51 = /*#__PURE__*/_createVNode("label", null, "웹 뷰로 열기(Off) / 웹 브라우저 링크로 열기(On)", -1)
const _hoisted_52 = { class: "form-group" }
const _hoisted_53 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_54 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editor = _resolveComponent("editor")
  const _component_file_upload = _resolveComponent("file-upload")
  const _component_SubmitButton = _resolveComponent("SubmitButton")

  return (_openBlock(), _createBlock("div", {
    class: ["card", { loading: _ctx.loading }]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("form", {
        onSubmit: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
      }, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode("div", _hoisted_6, [
                _withDirectives(_createVNode("select", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.post.category_id = $event)),
                  required: ""
                }, [
                  _hoisted_7,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categories, (item) => {
                    return (_openBlock(), _createBlock("option", {
                      key: item.id,
                      value: item.id
                    }, _toDisplayString(item.name), 9, ["value"]))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.post.category_id]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.post.title = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.post.title]
              ])
            ]),
            _createVNode("div", _hoisted_10, [
              _hoisted_11,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.post.contents_url = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.post.contents_url]
              ])
            ]),
            _createVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_editor, {
                ref: "customEditor",
                "set-contents": _ctx.post.desc
              }, null, 8, ["set-contents"])
            ])
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              _hoisted_16,
              _withDirectives(_createVNode("input", {
                type: "number",
                class: "form-control",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.post.order = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.post.order]
              ])
            ]),
            _createVNode("div", _hoisted_17, [
              _createVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode("div", _hoisted_20, [
                  _createVNode("label", _hoisted_21, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      class: "c-switch-input",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.post.show_view_count = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.post.show_view_count]
                    ]),
                    _hoisted_22
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_23, [
              _createVNode("div", _hoisted_24, [
                _hoisted_25,
                _createVNode("div", _hoisted_26, [
                  _createVNode("label", _hoisted_27, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      class: "c-switch-input",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.post.show = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.post.show]
                    ]),
                    _hoisted_28
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_29, [
              _createVNode("div", _hoisted_30, [
                _hoisted_31,
                _createVNode("div", _hoisted_32, [
                  _createVNode("label", _hoisted_33, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      class: "c-switch-input",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.post.pin = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.post.pin]
                    ]),
                    _hoisted_34
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_35, [
              _createVNode("div", _hoisted_36, [
                _hoisted_37,
                _createVNode("div", _hoisted_38, [
                  _createVNode("label", _hoisted_39, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      class: "c-switch-input",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.post.show_home = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.post.show_home]
                    ]),
                    _hoisted_40
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_41, [
                _hoisted_42,
                _withDirectives(_createVNode("input", {
                  type: "number",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.post.show_home_order = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.post.show_home_order]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_43, [
              _createVNode("div", _hoisted_44, [
                _hoisted_45,
                _createVNode("div", _hoisted_46, [
                  _createVNode("label", _hoisted_47, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      class: "c-switch-input",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.post.no_margin_layout = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.post.no_margin_layout]
                    ]),
                    _hoisted_48
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_49, [
              _createVNode("div", _hoisted_50, [
                _hoisted_51,
                _createVNode("div", _hoisted_52, [
                  _createVNode("label", _hoisted_53, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      class: "c-switch-input",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.contentViewType = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.contentViewType]
                    ]),
                    _hoisted_54
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_55, [
              _createVNode(_component_file_upload, {
                ref: "thumbnailFile",
                "set-preview-img": _ctx.setPreviewImg,
                "folder-name": 'post'
              }, null, 8, ["set-preview-img"])
            ]),
            _createVNode("div", _hoisted_56, [
              _createVNode(_component_file_upload, {
                title: "홈 썸네일",
                ref: "homeThumbnailFile",
                "set-preview-img": _ctx.setHomePreviewImg,
                "folder-name": 'post'
              }, null, 8, ["set-preview-img"])
            ])
          ])
        ]),
        _createVNode(_component_SubmitButton, {
          text: "저장",
          loadingText: " Saving...",
          isSubmitting: _ctx.isSubmitting
        }, null, 8, ["isSubmitting"])
      ], 32)
    ])
  ], 2))
}